import { toast } from "sonner";
import qnaClientApi from "@/api-client/qna-client";

export type QnAStatus = {
  status?: "enabled" | "disabled";
  movePopularQuestionsToTop?: boolean;
  approveQuestionsForModeration?: boolean;
  allowAnonymousQuestions?: boolean;
  limitOneQuestionPerAttendee?: boolean;
  clubSimilarQuestions?: boolean;
  whoCanComment?: "hosts" | "feature_guests" | "guests";
};

export const CreateQuestion = async (eventId: string, payload: any) => {
  try {
    const data = await qnaClientApi
      .post(`${eventId}/questions`, { json: { ...payload } })
      .json<any>();
    toast.success(data?.message || "Question created successfully");
    return data;
  } catch (error: any) {
    toast.error(error?.message || "Failed to create question");
    throw error;
  }
};

export const voteQuestion = async (eventId: string, questionId: string) => {
  try {
    const data = await qnaClientApi
      .put(`${eventId}/questions/${questionId}/vote`, { json: {} })
      .json<any>();
    toast.success(data?.message || "Question updated successfully");
    return data;
  } catch (error: any) {
    toast.error(error?.message || "Failed to fetch event data");
    throw error;
  }
};

export const deleteQuestion = async (eventId: string) => {
  try {
    const { data } = await qnaClientApi.get(`qna/${eventId}`).json<any>();
    return data;
  } catch (error: any) {
    toast.error(error?.message || "Failed to fetch event data");
    throw error;
  }
};

export const updateQnAPreference = async (eventId: string, payload: QnAStatus) => {
  try {
    const data = await qnaClientApi.patch(`qna/${eventId}`, { json: { ...payload } }).json<any>();
    toast.success(data?.message || "Q&A preference updated successfully.");
    return data;
  } catch (error: any) {
    toast.error(error?.message || "Failed to update Q&A preference.");
    throw error;
  }
};

export const updateQuestionStatus = async (eventId: string, questionId: string, payload: any) => {
  try {
    const data = await qnaClientApi
      .patch(`${eventId}/questions/${questionId}`, { json: { ...payload } })
      .json<any>();
    toast.success(data?.message || "Question updated successfully");
    return data;
  } catch (error: any) {
    toast.error(error?.message || "Failed to fetch event data");
    return;
    // throw error;
  }
};

export const addCommentToQuestion = async (
  eventId: string,
  questionId: string,
  payload: { text: string }
) => {
  try {
    const data = await qnaClientApi
      .post(`${eventId}/questions/${questionId}/comments`, { json: { ...payload } })
      .json<any>();
    toast.success(data?.message || "Question updated successfully");
    return data;
  } catch (error: any) {
    toast.error(error?.message || "Failed to fetch event data");
    return;
    // throw error;
  }
};

export const addReactionToComment = async (
  eventId: string,
  commentId: string,
  questionId: string,
  payload: { emoji: string }
) => {
  try {
    const data = await qnaClientApi
      .post(`${eventId}/questions/${questionId}/comments/${commentId}/reactions`, {
        json: { ...payload }
      })
      .json<any>();
    toast.success(data?.message || "Reaction Added successfully");
    return data;
  } catch (error: any) {
    toast.error(error?.message || "Failed to fetch data");
    return;
  }
};
